import i18n from '@/utils/i18n';
import React from 'react';
import { Button, ButtonSize } from '@sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';

interface Props {
  disabled?: boolean;
  /** Overrides the default "Publish edits" wording. */
  label?: string;
  loading: boolean;
  onPress: () => void;
}

export const PricingPublishButton: React.FC<Props> = ({
  disabled,
  label,
  loading,
  onPress,
}) => {
  const [styles] = useStyles();
  const title = label ?? i18n.t('pricing.publish.cta');

  return (
    <Button
      accessibilityLabel={title}
      disabled={disabled}
      loading={loading}
      onPress={onPress}
      size={ButtonSize.Small}
      style={styles.button}
    >
      {title}
    </Button>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
